import { z } from 'zod'

export const personalTokenRecordSchema = z
  .object({
    uid: z.string(),
    /** User friendly name */
    name: z.string().min(3).max(50),
    /** User friendly description */
    description: z.string().max(200).optional().default(''),
    /** Associate a personal token with a team */
    teamUid: z.string(),
    /** Token expiry time in unix timestamp */
    expiresAt: z.number().int(),
    /** Tracks if a token is blacklisted. Should not be used if token is revoked */
    revoked: z.boolean(),
  })
  .meta({ id: 'personal-token-record' })

export type PersonalTokenRecord = z.infer<typeof personalTokenRecordSchema>
